import { render, staticRenderFns } from "./RePaymart.vue?vue&type=template&id=3030cd3e&"
import script from "./RePaymart.vue?vue&type=script&lang=js&"
export * from "./RePaymart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports